import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";

import { MindRoutes } from "./Constants/routes";

const MindAll = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {MindRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/Mind/mindtab" />
      </Switch>
    </>
  );
};

export default MindAll;
